import { RealEstateDetails } from 'features/subscription-process/home-insurance/RealEstateDetails';
import { FC } from 'react';
import { useQuoteContractualizationData } from '../../store';

export const RiskRealEstate: FC = () => {
  const quoteData = useQuoteContractualizationData();

  if (!quoteData?.realEstate) {
    return <></>;
  }

  const { realEstate } = quoteData.realEstate;

  return <RealEstateDetails realEstate={realEstate} />;
};
